<template>
  <div v-if="getPermission.ccic.view">

    <ccic-photo-form ref="CcicPhotoForm" :on-data-refresh="doSearch"/>
    <move-ccic-container-form ref="MoveCcicContainerForm"/>
    <update-ccic-container-status-form ref="UpdateCcicContainerStatusForm"/>

    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h3>Pictures</h3>
        <calling-api path="/api/w/ccic/photo/get">
          <view-image :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
            <p>{{getPhotoName(p)}}</p>
            <p>{{p.refTimeStamp}}</p>
          </view-image>
        </calling-api>
      </md-dialog-content>
      <md-dialog-actions>
        <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"/>
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div>
              <md-field>
                <label>Company Code</label>
                <md-input v-model="searchRequest.companyCode" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <md-field>
                <label>IBD CCIC Status</label>
                <md-input v-model="searchRequest.ccicStatus" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div v-if="canSearchByTeam">
              <auto-complete-master-data-multiple-select
                  label="CCIC Team"
                  v-model="searchRequest.teams"
                  :prepared-options="getCcicTeamSearchOptions"
              />
            </div>
            <div v-if="canSearchByUsers">
              <auto-complete-master-data-multiple-select
                  :prepared-options="getCcicUserSearchOptions"
                  label="Users"
                  v-model="searchRequest.users">
              </auto-complete-master-data-multiple-select>
            </div>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div>
              <md-field>
                <label>CCIC App#</label>
                <md-input v-model="searchRequest.applicationNo" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <datepicker v-model="searchRequest.ccicDate.startDate">
                <label>CCIC date</label>
              </datepicker>
            </div>
            <div>
              <datepicker v-model="searchRequest.cargoCutoffDate.startDate">
                <label>Container Update Date</label>
              </datepicker>
            </div>
            <div>
              <datepicker v-model="searchRequest.containerCreateDate.startDate">
                <label>Container Create Date</label>
              </datepicker>
            </div>
            <div>
              <datepicker v-model="searchRequest.sealUpdateDate.startDate">
                <label>New Seal Change Date</label>
              </datepicker>
            </div>

            <div>
              <datepicker v-model="searchRequest.localSearch.startDate">
                <label>Container Local Date</label>
              </datepicker>
            </div>


          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div>
              <md-field>
                <label>Booking#</label>
                <md-input v-model="searchRequest.bookingNo" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <datepicker v-model="searchRequest.ccicDate.endDate">
                <label>To</label>
              </datepicker>
            </div>
            <div>
              <datepicker v-model="searchRequest.cargoCutoffDate.endDate">
                <label>To</label>
              </datepicker>
            </div>
            <div>
              <datepicker v-model="searchRequest.containerCreateDate.endDate">
                <label>To</label>
              </datepicker>
            </div>
            <div>
              <datepicker v-model="searchRequest.sealUpdateDate.endDate">
                <label>To</label>
              </datepicker>
            </div>


            <div>
              <datepicker v-model="searchRequest.localSearch.endDate">
                <label>To</label>
              </datepicker>
            </div>


          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div>
              <md-field>
                <label>PO</label>
                <md-input v-model="searchRequest.poNo" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <md-field>
                <label>Yard ID</label>
                <md-input v-model="searchRequest.yardId" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <md-field>
                <label>SO Number</label>
                <md-input v-model="sapNo" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <md-field>
                <label>Container #</label>
                <md-input v-model="searchRequest.containerNo" @keyup.enter="doSearch"/>
              </md-field>
            </div>

            
            <div>
              <auto-complete-master-data-multiple-select
                  label="Container Stats"
                  :prepared-options="containerStats"
                  v-model="searchRequest.disapprove"
              />
            </div>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div>
              <master-data-select label="Country" group="Country" v-model="searchRequest.country"/>
            </div>

            <div>
              <master-data-select label="State" group="State" v-model="searchRequest.state"/>
            </div>

            <div>
              <md-field>
                <label>SO Line</label>
                <md-input v-model="soItem" @keyup.enter="doSearch"/>
              </md-field>
            </div>

            <div>
              <master-data-select label="Inspection Type" group="InspectionType" v-model="inspectionType"/>
            </div>

            <div>
              <calling-api  path="/api/w/ccic/container/search">
                <md-card-actions>
                  <md-button @click="doSearch" class="btn-search-ccic-container md-primary md-raised">Search</md-button>
                  <md-button @click="clearSearch" class="md-raised">Clear</md-button>
                </md-card-actions>
              </calling-api >
            </div>
            <div>
              <calling-api path="/api/w/excel/generate">
                <md-card-actions>
                  <md-button v-if="items.length > 0" class="md-raised" @click="doDownloadExcel">Download</md-button>
                </md-card-actions>
              </calling-api>
            </div>
          </div>

          <div v-if="getPermission.ccic.edit" class="md-layout-item md-size-100 md-small-size-100">
            <calling-api :paths="['/api/w/ccic/container/update','/api/w/ccic/container/delete','/api/w/billOfLoads/confirmCCIC','/api/w/ccic/photo/get']">
              <calling-api path="/api/w/ccic/container/create" :not-display-error="true">
                <md-button class="md-raised" :disabled="!canEdit" @click="doChangeStatus">Update</md-button>
                <md-button class="md-raised" :disabled="!canEdit" @click="doMove">Move</md-button>
                <md-button v-if="getRole.isAcnIT" class="md-raised" :disabled="!canDelete" @click="doDelete">Delete</md-button>
                <!--<md-button class="md-raised" :disabled="!canCancel" @click="doCancel">Cancel</md-button>-->
                <!--<md-button class="md-raised" :disabled="!canSave" @click="doSave">Save</md-button>-->
                <md-button class="md-raised" :disabled="!canEdit" @click="doEditPhotos">Edit Photos</md-button>
                <md-button v-if = "ccicToSapFlag" class="md-raised" :disabled="!canConfirm" @click="doConfirm">Confirm</md-button>
                 <md-button v-if ="canSearchByUsers" class="md-raised" :disabled="!canUnConfirm" @click="doUnConfirm">UnConfirm</md-button>
                <md-button  v-if = "ccicToSapFlag" class="md-raised" @click="doBackGroundRun">BackGroundRun</md-button>
                <md-button  v-if = "ccicToSapFlag" class="md-raised" @click="doSyncApplication">SyncApplication</md-button>
                 
                <md-menu md-size="small">
                  <md-button class="md-raised" md-menu-trigger>Upload</md-button>
                  <md-menu-content>
                    <md-menu-item @click="downloadUploadTempalte">Download Template</md-menu-item>
                    <md-menu-item @click="toggleUpload">Upload</md-menu-item>
                    
                  </md-menu-content>

                  <md-button @click="doPhotos"  class="md-raised" md-menu-trigger><md-icon class = "custButton">cloud_upload</md-icon></md-button>
                    <md-checkbox v-model="filterConfirmed">
              Unconfirmed Containers
            </md-checkbox>
                </md-menu>
              </calling-api>
            </calling-api>
          </div>

        </div>
        <input type="file" class="md-hide" id="upload-ccic-container" accept=".xls,.xlsx" @change="handleUploadContainerFileSelected"/>
      </md-card-content>


    </md-card>

    <pagination :items="items">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2"></th>
                    <th class="header-cell w3">Status</th>
                    <th class="header-cell w8">SO#</th>
                    <th class="header-cell w8">SO Line#</th>
                    <th class="header-cell w8">PO#</th>
                    <th class="header-cell w8">PO Ref</th>
                    <th class="header-cell w8">Booking No.</th>
                    <th class="header-cell w8">CCIC App#</th>
                    <th class="header-cell w8">Container #</th>
                    <th class="header-cell w8">Old Seal #</th>
                    <th class="header-cell w8">New Seal #</th>
                    <th class="header-cell w8">New Seal Changed Date</th>
                    <th class="header-cell w8">New Seal Changed Time</th>
                    <th class="header-cell w8">User</th>
                    <th class="header-cell w8">Grade</th>
                    <th class="header-cell w8">Supplier ID</th>
                    <th class="header-cell w8">Yard ID</th>
                    <th class="header-cell w15">Pickup Location</th>
                    <th class="header-cell w3">Type</th>
                    <th class="header-cell w8">Loading Photos</th>
                    <th class="header-cell w8">CK Point Photos</th>
                    <th class="header-cell w8">Container Stats</th>
                    <th class="header-cell w8">Comment</th>
                    <th class="header-cell w8">Bales</th>
                    <th class="header-cell w8">Weight</th>
                    <th class="header-cell w8">Unit</th>
                    <th class="header-cell w8">Tare weight</th>
                    <th class="header-cell w8">VGM</th>
                    <th class="header-cell w8">Scale Ticket</th>
                    <th class="header-cell w8">Ticket Photo</th>
                    <th class="header-cell w8">IBD</th>
                    <th class="header-cell w5">Create From</th>
                    <th class="header-cell w8">Team Remark</th>
                    <th class="header-cell w5">Create Person</th>
                    <th class="header-cell w5">Create Date</th>
                    <th class="header-cell w5">Create Time</th>
                     <th class="header-cell w5">Local Date</th>
                    <th class="header-cell w5">Local Time</th>
                    <th class="header-cell w5">Update Person</th>
                    <th class="header-cell w5">Update Date</th>
                    <th class="header-cell w5">Update Time</th>
                    <th class="header-cell w5">Confirm Date</th>
                    <th class="header-cell w5">Confirm Time</th>
                    <th class="header-cell w8">LP date</th>
                    <th class="header-cell w8">CK date</th>
                    <th class="header-cell w8">LP user</th>
                    <th class="header-cell w8">CK user</th>
                    <th class="header-cell w8">Time Zone</th>
                    <th class="header-cell w8">SAP Status</th>
                    <th class="header-cell w15">SAP Message</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr :key="item.seqNo" v-for="item in pageItems">
                    <td class="body-cell w2">
                      <md-checkbox v-model="item.selected">
                        <span v-if="hasBeenChanged(item)">*</span>
                      </md-checkbox>
                    </td>
                    <td class="body-cell w3">
                     {{item.confirmStatus}}
                    </td>
                    <td class="body-cell w8">{{item.sapSo}}</td>
                    <td class="body-cell w8">{{item.soItem}}</td>
                    <td class="body-cell w8">{{item.application.poNo}}</td>
                    <td class="body-cell w8">{{item.poRef}}</td>
                    <td class="body-cell w8">{{item.application.bookingNo}}</td>
                    <td class="body-cell w8">{{item.application.applicationNo}}</td>
                    <td class="body-cell w8">{{item.containerNo}}</td>
                    <td class="body-cell w8">{{item.seal}}</td>
                    <td class="body-cell w8">{{item.newSeal}}</td>
                    <td class="body-cell w8">{{item.sealUpdatedAt | date}}</td>
                    <td class="body-cell w8">{{item.sealUpdatedAt | time}}</td>
                    <td class="body-cell w8">{{item.application.user}}</td>
                    <td class="body-cell w8">{{item.grade}}</td>
                    <td class="body-cell w8">{{item.application.supplierId}}</td>
                    <td class="body-cell w8">{{item.application.pickUpLocationId}}</td>
                    <td class="body-cell w15">{{item.application.pickUpLocationName}}</td>
                    <td class="body-cell w3">
                      <div v-if="item.type === 'GENERAL'">L</div>
                      <div v-if="item.type === 'CHECK_POINT'">C</div>
                      <div v-if="item.type === 'SUPPLIER'">SP</div>
                    </td>
                    <td class="body-cell w8">
                      <template v-if="item.photoCount > 0 && (item.type === 'GENERAL'
                                     || (item.user === 'GST_SYSTEM' && (item.type === '' || item.type == null)))"
                        >
                        <a href="" @click.prevent="toggleItemPhoto(item,'L')">{{item.photoCount}} photos</a>
                      </template>
                      <template v-else>
                        <span>0 photos</span>
                      </template>
                    </td>
                    <td class="body-cell w8">
                      <template v-if="item.photoCount > 0 && (item.type === 'CHECK_POINT'||item.type === 'SUPPLIER')">
                        <a href="" @click.prevent="toggleItemPhoto(item)">{{item.photoCount}} photos</a>
                      </template>
                      <template v-else>
                        <span>0 photos</span>
                      </template>
                    </td>
                    <td class="body-cell w8">{{item.disapprove}}</td>
                    <td class="body-cell w8">{{item.disapproveComment}}</td>
                    <td class="body-cell w8">{{item.bales}}</td>
                    <td class="body-cell w8">{{item.tareWeight}}</td>
                    <td class="body-cell w8">&nbsp;</td>
                    <td class="body-cell w8">{{item.tareWeight}}</td>
                    <td class="body-cell w8">{{item.vgmWeight}}</td>
                    <td class="body-cell w8">&nbsp;</td>
                    <td class="body-cell w8">&nbsp;</td>
                    <td class="body-cell w8">{{item.application.ibd}}</td>
                    <td class="body-cell w5">{{!!item.createByWeb ? 'Web' : 'Mobile'}}</td>
                    <td class="body-cell w8">{{item.teamRemark}}</td>
                    <td class="body-cell w5">{{item.createdBy}}</td>
                    <td class="body-cell w5">{{item.createdAt | date}}</td>
                    <td class="body-cell w5">{{item.createdAt | time}}</td>
                     <td class="body-cell w5">{{item.refTimeStamp | date}}</td>
                     <td class="body-cell w5">{{item.refTimeStamp | time}}</td>
                    <td class="body-cell w5">{{item.updatedBy}}</td>
                    <td class="body-cell w5">{{item.updatedAt | date}}</td>
                    <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    <td class="body-cell w5">{{item.confirmAt | date}}</td>
                    <td class="body-cell w5">{{item.confirmAt | time}}</td>
                    <td class="body-cell w8">&nbsp;</td>
                    <td class="body-cell w8">&nbsp;</td>
                    <td class="body-cell w8">&nbsp;</td>
                    <td class="body-cell w8">&nbsp;</td>
                    <td class="body-cell w8">{{item.createdAt | tz}}</td>
                    <td class="body-cell w8">{{item.sapStatus}}</td>
                    <td class="body-cell w15">{{item.sapMessage}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>

.custButton {
    margin: 25px;
}

.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

</style>

<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
  //import api from "../api";
  import { newAPIPost } from '../api';
  import UpdateCcicContainerStatusForm from "../components/UpdateCcicContainerStatusForm.vue";
  import CcicPhotoForm from "../components/CcicPhotoForm.vue";
  import MoveCcicContainerForm from "../components/MoveCcicContainerForm.vue";
  import parseXls from "../utils/parseXls";
  import callingApiCenter from "../components/CallingApiCenter.vue";


  


  const containerStats = [
    {
      id: 'APPROVE',
      name: 'APPROVE',
    },
    {
      id: 'REJECT',
      name: 'REJECT',
    },
    {
      id: 'UNLOAD',
      name: 'UNLOAD',
    },
    {
      id: 'UNLOAD&REJECT',
      name: 'UNLOAD&REJECT',
    },

    {
      id: 'PUNCH',
      name: 'PUNCH',
    },

    {
      id: 'PARTIAL_UNLOAD',
      name: 'PARTIAL UNLOAD',
    },

    {
      id: 'NA',
      name: 'NA',
    },
  ];

  const photoMetaCheckPoint = [
    {
      display: "BOL",
      key: "SB",
      fileName: "-BOL",
    },
    {
      display: "OLD SEAL",
      key: "C3",
      fileName: " (3).JPG",
    },
    {
      display: "LEFT DOOR OPEN  RIGHT DOOR CLOSED",
      key: "CS",
      fileName: "-C.JPG",
    },
    {
      display: "RIGHT  DOOR CLOSED WITH INSPECTOR",
      key: "COS",
      fileName: "-OldSeal.JPG",
    },
    {
      display: "NEW SEAL",
      key: "CNS",
      fileName: "-S.JPG",
    },
    {
      display: "1/3 LOADED",
      key: "C1",
      fileName: " (1).JPG",
    },
    {
      display: "1/2 LOADED",
      key: "C2",
      fileName: " (2).JPG",
    },
    {
      display: "OTHERS",
      key: "C01",
      fileName: "-OTHER1.JPG",
    },
    {
      display: "OTHERS",
      key: "C02",
      fileName: "-OTHER2.JPG",
    },
    {
      display: "OTHERS",
      key: "C03",
      fileName: "-OTHER3.JPG",
    },
    {
      display: "OTHERS",
      key: "C04",
      fileName: "-OTHER4.JPG",
    },
    {
      display: "OTHERS",
      key: "C0",
      fileName: "-OTHER5.JP",
    },
  ];

  const photoMetaLoading = [
    {
      display: "1/3 LOADED",
      key: "P1",
      fileName: " (1)L.JPG",
    },
    {
      display: "1/2 LOADED",
      key: "P2",
      fileName: " (2)L.JPG",
    },
    {
      display: "LEFT DOOR OPEN , RIGHT DOOR CLOSED",
      key: "P3",
      fileName: " (3)L.JPG",
    },
    {
      display: "RIGHT DOOR CLOSED WITH INSPECTOR",
      key: "PC",
      fileName: " CL.JPG",
    },
    {
      display: "SEAL NUMBER",
      key: "PS",
      fileName: " SL.JPG",
    },
    {
      display: "OTHERS",
      key: "O1",
      fileName: "OTHER1L.JPG",
    },
    {
      display: "OTHERS",
      key: "O2",
      fileName: "OTHER2L.JPG",
    },
    {
      display: "OTHERS",
      key: "O3",
      fileName: "OTHER3L.JPG",
    },
    {
      display: "OTHERS",
      key: "O4",
      fileName: "OTHER4L.JPG",
    },
    {
      display: "OTHERS",
      key: "O",
      fileName: "OTHER5L.JPG",
    },
  ];

  const uploadCols = [
    'user',
    'poNo',
    'bookingNo',
    'pickUpLocationId',
    'containerNo',
    'type',
    'seal',
    'newSeal',
    'disapprove',
    'disapproveComment',
    'grade',
    'tareWeight',
    'vgmWeight',
  ];

  const getInitSearch = () => ({
    ccicDate: {
      startDate: null,
      endDate: null,
    },
    cargoCutoffDate: {
      startDate: null,
      endDate: null,
    },
    ccicStatus: null,
    companyCode: null,
    user: null,
    teams: [],
    users: [],
    applicationNo: null,
    bookingNo: null,
    poNo: null,
    yardId: null,
    supplierId: null,
    containerNo: null,
    ibd: null,
    state: null,
    country: null,
    sealNo: null,
    containerCreateDate: {
      startDate: null,
      endDate: null,
    },
    sealUpdateDate: {
      startDate: null,
      endDate: null,
    },
    localSearch: {
      startDate: null,
      endDate: null,
    },

    disapprove: [],
   
  });

  export default {
    data: () => ({
      searchRequest: getInitSearch(),
      dialog: {
        isShowing: false,
      },
      items: [],
      isPictureModalShowing: false,
      usersToSearch: [],
      photos: [],
      testphotos: [],
      photoZipFileName: '',
      filePrefixForEachFile: '',
      containerStats,
      inspectionType: null,
       ccicToSapFlag : true,
       filterConfirmed : false,
       sapNo: '',
       soItem: '',
       loadpickeys: ['O1','O2','O3','O4','O5','P1','P2','P3','PC','PS'],

    }),
    components: {
      MoveCcicContainerForm,
      UpdateCcicContainerStatusForm,
      CcicPhotoForm,
      callingApiCenter,
    },
    watch: {
      getCcicContainers(val) {
        this.updateItems(val);
      },
      // eslint-disable-next-line
      "searchRequest.teams"() {
         this.searchRequest.users = [];
      },

    },
    computed: {
      ...mapGetters([
        'getCcicContainers',
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
      ]),
      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },
      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },
      canCopy() {
        return this.getSelectedItems.length === 1;
      },
      canDelete() {
       // return this.getSelectedItems.length === 1;
        const items = this.getSelectedItems.filter(it => it.confirmStatus);
          return items.length === 0;
      },
      canConfirm()
      {
          const items = this.getSelectedItems.filter(it => it.confirmStatus);
          console.log(items);
          const confirmItem = this.getSelectedItems.filter(it => !it.disapprove);
          console.log(confirmItem);
          return confirmItem.length === 0 && items.length === 0;

      },

      canUnConfirm()
      {
          const items = this.getSelectedItems.filter(it => it.confirmStatus != "C");
          return items.length === 0;
      },

      canNew() {
        return this.getEditingItems.length === 0;
      },
      canChangeStatus() {
        if (this.getSelectedItems.length === 1) {
          return this.getSelectedItems[0].type === 'CHECK_POINT' && this.getEditingItems.length === 0;
        }
        return false;
      },
      canEdit() {
        //return this.getSelectedItems.length === 1 && this.getEditingItems.length === 0;
         const items = this.getSelectedItems.filter(it => it.confirmStatus);
          return items.length === 0;
      },
      canCancel() {
        return this.getEditingItems.length === 1;
      },
      canSave() {
        return !!_(this.getEditingItems)
          .find(it => !!this.hasBeenChanged(it));
      },
      canSearchByTeam() {
        return this.getUserProfile.ccicRole === 'CCIC_ROLE_ADMIN' || this.getUserProfile.ccicRole === 'CCIC_ROLE_MANAGER';
      },
      getAllCcicTeamOptions() {
        return this.getMasterDataAsSelectOptionByGroup('CCIC_TEAM');
      },
      getCcicTeamSearchOptions() {
        const { ccicRole, ccicTeams } = this.getUserProfile;
        if (ccicRole === 'CCIC_ROLE_ADMIN') {
          return this.getAllCcicTeamOptions;
        }
        return this.getAllCcicTeamOptions.filter(it => _(ccicTeams)
          .contains(it.id));
      },
      getCcicUserSearchOptions() {
        const ccicUsers = this.usersToSearch;
        const selectedTeams = this.searchRequest.teams;
        if (selectedTeams.length === 0) {
          return ccicUsers;
        }
        return ccicUsers.filter(it => _.intersection(selectedTeams, it.ccicTeams).length > 0);
      },
      canSearchByUsers() {
        const { ccicRole } = this.getUserProfile;
        return ccicRole === 'CCIC_ROLE_ADMIN' || ccicRole === 'CCIC_ROLE_MANAGER';
      },
    },
    async mounted() {
      const cachedSearchRequest = this.$store.state.ccicContainer.searchRequest;
      if (cachedSearchRequest) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      }

      this.updateItems(this.getCcicContainers);
      
      const { ccicRole, ccicTeams } = this.getUserProfile;
      //var allCcicUsers1 = [];
      //var allCcicUsers2 = [];
      if (ccicRole !== 'CCIC_ROLE_INSPECTOR') {
        // allCcicUsers1 = await this.$store.dispatch(
        //   'getUsersByCategory',
        //   {
        //     category: 'G',
        //     dontFilterDisabled: true,
        //   },
        // );
        // allCcicUsers2 = await this.$store.dispatch(
        //   'getUsersByCategory',
        //   {
        //     category: 'G1',
        //     dontFilterDisabled: true,
        //   },

        // );
        //const allCcicUsers = allCcicUsers1.concat(allCcicUsers2);
        const allCcicUsers1 = await this.$store.dispatch(
          'getUsersByCategory',
          {
            category: 'G',
            dontFilterDisabled: true,
          },
        );
        const allCcicUsers2 = await this.$store.dispatch(
          'getUsersByCategory',
          {
            category: 'G1',
            dontFilterDisabled: true,
          },
        );
        const allCcicUsers = allCcicUsers1.concat(allCcicUsers2);
        console.log(JSON.stringify(allCcicUsers));
        if (ccicRole === 'CCIC_ROLE_MANAGER') {
          this.usersToSearch = allCcicUsers.filter(it => _.intersection(it.ccicTeams, ccicTeams).length > 0);
        } else {
          this.usersToSearch = allCcicUsers;
        }
      }
    },
    methods: {
      doNew() {
        this.$refs.NewCcicContainerForm.openDialog();
      },
      updateItems(itemsSource) {
        var items = JSON.parse(JSON.stringify(itemsSource));
        items.forEach((it) => {
          it.selected = false;
          it.editing = false;
          console.log(it.sapSo)
        });
        
        

        if (this.sapNo != '')
        {
          items = items.filter(it => it.sapSo === this.sapNo);
          
          console.log(this.sapNo);
          
        }


         if (this.soItem != '')
        {
          items = items.filter(it => it.soItem === this.soItem);
        }
        

        if (this.inspectionType != null)
        {
         if (this.filterConfirmed === true)
        {
           this.items = items.filter(it => it.type === this.inspectionType).filter(it => it.confirmStatus != "C");
        }
        else
        {
          this.items = items.filter(it => it.type === this.inspectionType);
        }
        }
        else
        {
          if (this.filterConfirmed === true)
        {
           this.items = items.filter(it => it.confirmStatus != "C");
        }
        else
        {
           this.items = items
        }
          
        }
       console.log(this.items);
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },
      doSearch() {
        
        

        const {
          users,
          teams,
          cargoCutoffDate,
          containerCreateDate,
          sealUpdateDate,
          localSearch,
          poNo,
          bookingNo,
          containerNo,
        } = this.searchRequest;

        console.log("Local reqeust date")
        console.log(containerCreateDate);
         console.log(sealUpdateDate);
          console.log(localSearch);

        if (!(containerCreateDate.startDate || sealUpdateDate.startDate || localSearch.startDate || cargoCutoffDate.startDate ) && !(!!poNo || !!bookingNo || !!containerNo)) {
          window.alert('Must at least provide Container Create Date or Seal Change Date PO/Booking #/Container # to perform search');
          return;
        }
        const { ccicRole } = this.getUserProfile;
        console.log(`ccicRole = ${ccicRole}`);

         this.searchRequest.usersInTeam = [];

        if (ccicRole === "CCIC_ROLE_INSPECTOR") {
          this.searchRequest.users = [this.getUserProfile.username];
        } else if (users.length === 0 && teams.length > 0) {
          this.searchRequest.usersInTeam = this.usersToSearch
            .filter(u => _.intersection(teams, u.ccicTeams).length > 0)
            .map(it => it.id);
        } else if (users.length === 0 && teams.length === 0) {
          if (ccicRole === "CCIC_ROLE_MANAGER") {
            this.searchRequest.usersInTeam = this.usersToSearch.map(it => it.id);
          }
        }

        this.$store.dispatch('loadCcicContainers', this.searchRequest);

        console.log(JSON.stringify("CONTAINERS"));
      console.log(JSON.stringify(this.getCcicContainers));
      },
      clearSearch() {
        _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
          .each((it) => {
            console.log(it);
            it.click();
          });
        this.$nextTick(() => {
          this.searchRequest = getInitSearch();
        });

        
      },



      async toggleItemPhoto(item,phototype) {
        this.isPictureModalShowing = true;
        //var photos = (await api.post('/api/w/ccic/photo/get', { containerSeqNo: item.seqNo }))
        var photos = (await newAPIPost('/api/w/ccic/photo/get', { containerSeqNo: item.seqNo }))
        if (phototype == 'L')
        {
          this.photos = photos.filter(it => this.loadpickeys.includes(it.photoKey));
        }
        
        this.photoZipFileName = `${item.application.bookingNo}_${item.application.poNo}_${item.containerNo}.zip`;
        this.filePrefixForEachFile = `${item.containerNo}-`;
        console.log(photos)

      },

       doDownload() {
        this.downloading = true;
        const zipFileName = this.zipFileName || 'pictures.zip';
        const promises = _(this.testphotos)
          .map((photo) => {
            const a = document.createElement('a');
            a.href = photo.photoUrl;

            const req = {
              method: 'GET',
              mode: 'no-cors',
              cache: 'default',
            };

            const pathName = a.pathname;
            console.log(pathName);
            return fetch(pathName, req)
              .then(response => ({
                response,
                photo,
              }));
          });


        Promise.all(promises)
          .then((results) => {
            this.downloading = false;
            console.log(`aa`, results);
            const zip = new JSZip();
            _.chain(results)
              .groupBy(it => it.photo.containerNo)
              .each((values, k) => {
                console.log(values[0].photo.bookingNo)
                const target = (`${k}` !== `null`) ? zip.folder(k) : zip;
                _(values)
                  .each(({ response,photo }) => {
                    const res = response;
                    let filename = photo.containerNo + "-" + decodeURI(res.url.replace(/.*\//g, ""));
                    if (!filename.endsWith('png') || !filename.endsWith('jpg')) {
                      filename += '.png';
                    }
                    console.log(`filename=${filename}`);
                    const blob = res.blob();
                    target.file(filename, blob, { binary: true });
                  });
              });

            zip.generateAsync({ type: "blob" })
              .then((blob) => {
                const a = $("<a style='display: none;'/>");
                const url = window.URL.createObjectURL(blob);
                a.attr("href", url);
                a.attr("download", zipFileName);
                $("body")
                  .append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();
              });
          })
          .catch((e) => {
            console.error(e);
            this.downloading = false;
          });
      },


      async doPhotos(){
        this.testphotos = []
             const apis =  _(this.items).map((it) => 
       {
         console.log(it)
         //return new Promise(async (resolve) => await api.post('/api/w/ccic/photo/get', { containerSeqNo: it.seqNo })
         return new Promise(async (resolve) => await newAPIPost('/api/w/ccic/photo/get', { containerSeqNo: it.seqNo })
          .then((result) => {
                      console.log("result")
                       console.log(result)
                      result.forEach((it2) => {
                         it2.containerNo = it.containerNo
                         it2.bookingNo = it.application.bookingNo
                         this.testphotos.push(it2)
                      })
                      
                        resolve(it);
                      })
                      .catch((err) => {
                         console.log(err)
                        resolve(it);
                      }));
                      
                      
                      
                      });
         console.log(apis)
         Promise.all(apis)
                .then((temp) => {
                 
             
                 console.log("111");
                 console.log(temp);
                 this.doDownload();
                 
                 
                });
       



      },





      doDownloadExcel() {
        const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'Conatiner.xls',
          1,
        );
        request.heads = _(request.heads)
          .take(52);

        request.rows = _(this.items)
          .map(item => [
            item.confirmStatus,
            item.sapSo,
            item.soItem,
            _.lookup(item, 'application.poNo'),
            _.lookup(item, 'poRef'),
            _.lookup(item, 'application.bookingNo'),
            _.lookup(item, 'application.applicationNo'),
            item.containerNo,
            item.seal,
            item.newSeal,
            dateFormat.date(item.sealUpdatedAt),
            dateFormat.time(item.sealUpdatedAt),
            _.lookup(item, 'application.user'),
            item.grade,
            _.lookup(item, 'application.supplierId'),
            _.lookup(item, 'application.pickUpLocationId'),
            _.lookup(item, 'application.pickUpLocationName'),
            item.type === 'GENERAL' ? 'L' : 'C',
            `${item.type === 'GENERAL' ? item.photoCount : 0} photos`,
            `${item.type === 'CHECK_POINT' ? item.photoCount : 0} photos`,
            item.disapprove,
            item.disapproveComment,
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            _.lookup(item, 'application.ibd'),
            !!item.createByWeb ? 'Web' : 'Mobile',
            item.teamRemark,
            item.createdBy,
            dateFormat.date(item.createdAt),
            dateFormat.time(item.createdAt),
            dateFormat.date(item.refTimeStamp),
            dateFormat.time(item.refTimeStamp),
            item.updatedBy,
            dateFormat.date(item.updatedAt),
            dateFormat.time(item.updatedAt),
            '',
            '',
            '',
            '',
            dateFormat.tz(item.createdAt),
            item.sapStatus,
            item.sapMessage,
          ]);

        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },
      getPhotoName(photo) {
        const photoName = decodeURI(photo.photoUrl.replace(/.*\//g, ""));
        return `${this.filePrefixForEachFile || ''}${photoName}`;
      },
      hasBeenChanged(item) {
        const lhs = _(this.getCcicContainers)
          .find(it => it.seqNo === item.seqNo);
        if (lhs) {
          return (lhs.poNo !== item.poNo)
            || (lhs.bookingNo !== item.bookingNo)
            || (lhs.pickUpLocationId !== item.pickUpLocationId)
            || (lhs.applicationNo !== item.applicationNo);
        }
        return false;
      },
      doChangeStatus() {
        const selectedItem = this.getSelectedItems[0];
        this.$refs.UpdateCcicContainerStatusForm.openDialog(selectedItem);
      },
      doMove() {
        const selectedItem = this.getSelectedItems[0];
        this.$refs.MoveCcicContainerForm.openDialog(selectedItem);
      },
      async doDelete() {
        const selectedItem = this.getSelectedItems[0];
        const { user, seqNo } = selectedItem;
        if (window.confirm('Delete Container?')) {
          //await api.post('/api/w/ccic/container/delete', {
          await newAPIPost('/api/w/ccic/container/delete', {
            user,
            seqNo,
          });
          this.doSearch();
        }
      },

       async doConfirm() {
        
        //  this.getSelectedItems.forEach((it) => {
        //    it.confirmIndicator = true;
        //    //it.confirmStatus = "C";
        // });

        //  await Promise.all(this.getSelectedItems.map(it => api.post('/api/w/ccic/container/update', it)));
        const requests = _(this.getSelectedItems).map(it => {
          return {
            user: it.user,
            seqNo: it.seqNo,
          
          };
        });
         //await api.post('/api/w/billOfLoads/confirmCCIC', {
         await newAPIPost('/api/w/billOfLoads/confirmCCIC', {
            ccics: requests,
          });
        this.doSearch();
      },


        async doUnConfirm() {
        
        //  this.getSelectedItems.forEach((it) => {
        //    it.confirmIndicator = true;
        //    //it.confirmStatus = "C";
        // });

        //  await Promise.all(this.getSelectedItems.map(it => api.post('/api/w/ccic/container/update', it)));
        const requests = _(this.getSelectedItems).map(it => {
          return {
            user: it.user,
            seqNo: it.seqNo,
          
          };
        });
         //await api.post('/api/w/billOfLoads/confirmCCIC', {
         await newAPIPost('/api/w/billOfLoads/confirmCCIC', {
            ccics: requests,
            action: "UNCONFIRM",
          });
        this.doSearch();
      },


    
      async  doBackGroundRun(){
           //await api.post('/api/w/billOfLoads/confirmCCIC', {
           await newAPIPost('/api/w/billOfLoads/confirmCCIC', {
            action: "BG",
          });
          this.doSearch();

       
    

      },


      async doSyncApplication(){
           //await api.post('/api/w/billOfLoads/confirmCCIC', {
           await newAPIPost('/api/w/billOfLoads/confirmCCIC', {
            action: "SA",
          });
          this.doSearch();
      },

      doEditPhotos() {
        const selectedItem = this.getSelectedItems[0];
        this.$refs.CcicPhotoForm.openDialog(
          `${selectedItem.application.bookingNo}_${selectedItem.application.poNo}_${selectedItem.containerNo}.zip`,
          selectedItem.seqNo,
          "CCIC_CONTAINER",
          selectedItem.type === "GENERAL" ? photoMetaLoading : photoMetaCheckPoint,
          { containerSeqNo: selectedItem.seqNo },
        );
      },
      downloadUploadTempalte() {
        downloadExcel(
          [
            uploadCols,
            [
              'user',
              'P01',
              'B01',
              '1010005',
              'C01',
              'GENERAL',
              'seal',
              'newSeal',
              'disapprove',
              'disapproveComment',
              'grade',
              0,
              0,
            ],
          ],
          'CCIC_Container',
          'CCIC_Container.xlsx',
        );
      },
      toggleUpload() {
        this.$el.querySelector('#upload-ccic-container')
          .click();
      },
      handleUploadContainerFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              if (!_.isEqual(headCols, uploadCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-ccic-container').value = '';

              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/ccic/container/create',
                      {
                        user: it[i++],
                        poNo: it[i++],
                        bookingNo: it[i++],
                        pickUpLocationId: it[i++],
                        containerNo: it[i++],
                        type: it[i++],
                        seal: it[i++],
                        newSeal: it[i++],
                        disapprove: it[i++],
                        disapproveComment: it[i++],
                        grade: it[i++],
                        tareWeight: it[i++],
                        vgmWeight: it[i++],
                      },
                    )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'CCIC_Container',
                    'CCIC_Container-UploadResult.xlsx',
                  );
                });
            });
        }
      },
    },
  };

</script>
